import {ReadOnlyApiService} from "@/services/api/api.base.js";

export class DCLApiService extends ReadOnlyApiService {
  constructor(resource, notifier, callback) {
    super(resource, notifier, callback);
  }


  async getHistory(params) {
    let res = []
    const data = await super.get('history', params);
    if (data == undefined || data.length == 0) {
      return res
    }  
    if (data[0]) {
      res = data[0]
    }
    return res
    // return data.map((item) => this._parseDetail(DoughMap, item));
  }

  async getListDT(params = {}) {
    let res = []
    const data = await super.get('listdt', params);
    if (data == undefined || data.length == 0) {
      return res
    }  
    if (data[0].ListDts) {
      res = data[0].ListDts
    }
    return res
    // return data.map((item) => this._parseDetail(DoughMap, item));
  }

  async getListDecl(params = {}) {
    let res = []
    const data = await super.get('listdecl', params);
    if (data == undefined || data.length == 0) {
      return res
    }  
    if (data[0]) {
      res = data[0]
    }
    return res
    // return data.map((item) => this._parseDetail(DoughMap, item));
  }

  async getDT(params) {
    let res = []
    const data = await super.get('dtmain', params);
    if (data == undefined || data.length == 0) {
      return res
    }  
    if (data[0]) {
      res = data[0]
    }
    return res
    // return data.map((item) => this._parseDetail(DoughMap, item));
  }
}